import BackupDownloadButton from './BackupDownloadButton'
import type { BackupFileStatus } from '../api/backupApi'
import { Badge } from '@/components/custom/badge'
import { formatDate } from '@/utils/timeZoneUtils'

type MobileBackupFileCardProps = {
  file: BackupFileStatus
}

export default function MobileBackupFileCard({
  file,
}: MobileBackupFileCardProps) {
  return (
    <div
      key={file.id}
      className="rounded-md border bg-white p-4 flex flex-col gap-2 shadow-sm"
    >
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="font-semibold text-sm text-gray-700">
            {file.name}
          </span>
          <Badge
            color={file.available ? 'green' : 'gray'}
            variant="soft"
            size="sm"
          >
            {file.available ? 'Available' : 'Unavailable'}
          </Badge>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-500">
            {formatDate(file.createdTime, 'DD/MM/YYYY hh:mm A')}
          </span>
          <BackupDownloadButton fileId={file.id} />
        </div>
      </div>
    </div>
  )
}
